// extracted by mini-css-extract-plugin
module.exports = {"isolate":"Layout_isolate__4bew3","mainContent":"Layout_mainContent__fy3Ml"};